// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:39:14.773Z
// Property: Chardonnay (ID: 6767906449165591)
// Collections: 17 amenities, 3 floorplans (live), 36 photos, 70 POIs, 2 reviews, 1 virtual tours, 5 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165591",
  "property_external_id": "jkp5nj7",
  "property_zillow_url": "https://www.zillow.com/apartments/tulsa-ok/chardonnay/5XhzSr/",
  "property_apartments_url": "https://www.apartments.com/chardonnay-tulsa-ok/jkp5nj7/",
  "property_google_business_url": "https://www.google.com/maps/place/Chardonnay+Apartments/data=!4m2!3m1!1s0x0:0xe3533eaeeb8b668d?sa=X&ved=2ahUKEwjm64T-87ySAxVrkIkEHTbDLh4Q_BJ6BAgXEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "chardonnay",
  "property_name": "Chardonnay",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/chardonnay/",
  "property_domain": null,
  "property_address": "7209 South 92nd East Avenue",
  "property_full_address": "7209 South 92nd East Avenue, Tulsa, OK, 74133",
  "property_address_1": "7209 South 92nd East Avenue",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74133",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0588",
  "property_address_longitude": "-95.873",
  "property_email": "chardonnay@caseusa.com",
  "property_phone": "(539) 379-5223",
  "property_call_tracking_phone": "844-580-1171",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Chardonnay in Tulsa, Oklahoma, where stylish one and two-bedroom apartments offer comfort and convenience. Dive into refreshing pool days, unwind in the clubhouse, or savor evenings on your private balcony. With amenities like high-speed internet, a pet play area, and modern kitchens, your perfect home awaits. Schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "**Discover Your Perfect Retreat at Chardonnay Apartments in Tulsa, OK!**\n\nWelcome to Chardonnay, where comfort meets convenience in the heart of Tulsa, Oklahoma. Our vibrant apartment community offers an array of thoughtfully designed floor plans, including spacious one and two-bedroom options to cater to your unique lifestyle. Each apartment is equipped with modern amenities ensuring a hassle-free living experience. \n\nDive into relaxation at our sparkling pool or enjoy social gatherings at the inviting clubhouse. For those who work from home, our business center provides the perfect setting for productivity. Need a break? Step outside to our beautifully landscaped courtyard or let your furry friend explore the pet play area. Connectivity is never an issue with our high-speed Wi-Fi and 24-hour access.\n\nYour new home will feature essential comforts, including air conditioning, in-unit washers and dryers, dishwashers, and ample storage with walk-in closets. Enjoy the luxury of a fireplace for cozy nights, or unwind on your private balcony or patio. Each apartment also comes with modern kitchen appliances and stylish fixtures, blending functionality with contemporary design.\n\nChardonnay not only caters to your living needs but also enriches your lifestyle with excellent amenities that make every day feel like a retreat. We invite you to explore our community and envision your next chapter here.\n\nFind your new home today at Chardonnay Apartments—browse our availability or schedule a tour to visit our community! Your ideal living space awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019fb44b-40b1-72bf-9645-8de43564854c.webp",
  "property_featured_image_media": {
    "alt_text": "Outdoor seating area with a grill and dining table by the pool.",
    "public_id": "019fb44b-40b1-72bf-9645-8de43564854c",
    "storage_key": "property/6767906449165591/019fb44b-40b1-72bf-9645-8de43564854c.webp",
    "width": 1280,
    "height": 853
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "200",
  "property_year_built": "1983",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "98",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Maximum of 2 pets per unit. Maximum weight: 80 lb per pet.",
  "property_pet_policy_description": "Cats and dogs allowed. One‑time pet fee: $500 per pet. Monthly pet rent: $25 per pet. Maximum of 2 pets per unit. Maximum weight: 80 lb per pet.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://chardonnayapartmentstulsa.securecafe.com/onlineleasing/chardonnay/floorplans.aspx",
  "property_resident_portal_url": "https://chardonnayapartmentstulsa.securecafe.com/residentservices/chardonnay/userlogin.aspx",
  "property_apply_now_url": "https://chardonnayapartmentstulsa.securecafe.com/onlineleasing/chardonnay/register.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3a-d947-771e-a64a-f4cc9e06d28e.webp",
  "property_primary_logo_media": {
    "alt_text": "Chardonnay Apartment Homes logo",
    "public_id": "019cfb3a-d947-771e-a64a-f4cc9e06d28e",
    "storage_key": "property/6767906449165591/019cfb3a-d947-771e-a64a-f4cc9e06d28e.webp",
    "width": 340,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-f76e-70e8-9fa0-4ff207e02046.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3b-f76e-70e8-9fa0-4ff207e02046",
    "storage_key": "property/6767906449165591/019cfb3b-f76e-70e8-9fa0-4ff207e02046.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3c-17ec-7520-99fa-ec1c3784985d.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Chardonnay Apartment Homes logo",
    "public_id": "019cfb3c-17ec-7520-99fa-ec1c3784985d",
    "storage_key": "property/6767906449165591/019cfb3c-17ec-7520-99fa-ec1c3784985d.webp",
    "width": 340,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3c-244f-73e8-a16b-ed0d204006e2.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Chardonnay Apartment Homes logo",
    "public_id": "019cfb3c-244f-73e8-a16b-ed0d204006e2",
    "storage_key": "property/6767906449165591/019cfb3c-244f-73e8-a16b-ed0d204006e2.webp",
    "width": 340,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#b45232",
  "property_secondary_color": "#0e3147",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "500 - 900",
  "property_sqft_min": "500",
  "property_sqft_max": "900",
  "property_price_range": "859 - 1149",
  "property_price_min": "859",
  "property_price_max": "1149",
  "property_available_units": 6,
  "property_facebook_url": "https://www.facebook.com/ChardonnayTulsa/",
  "property_instagram_url": "https://www.instagram.com/chardonnayapts/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJJ8xPo76NtocRjWaL664-U-M",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/chardonnay-apartments-tulsa-2",
  "property_tiktok_url": "https://www.tiktok.com/@chardonnaycase",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Chardonnay",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection in Your New Home",
  "property_home_amenities_blurb": "Welcome to Chardonnay in Tulsa, where comfort meets convenience. Choose from our thoughtfully designed one and two-bedroom floor plans, each equipped with modern amenities like high-speed internet, a cozy fireplace, and a serene balcony. Dive into luxury at our pool, unwind in the clubhouse, or let your pet roam free in our play area.",
  "property_home_floorplans_blurb": "Welcome to Chardonnay in Tulsa, Oklahoma, where comfort meets style. Choose from our thoughtfully designed one and two-bedroom layouts, crafted for your unique lifestyle. Browse our available apartment homes today and uncover the perfect floor plan that feels like home, tailored just for you.",
  "property_home_gallery_blurb": "Welcome to Chardonnay in Tulsa, Oklahoma, where your ideal lifestyle awaits! Choose from our spacious one and two-bedroom floor plans, enhanced by resort-style amenities like a sparkling pool, modern clubhouse, and pet-friendly courtyard. Picture yourself living here, complete with high-speed Wi-Fi, a cozy fireplace, and private balcony bliss.",
  "property_home_neighborhood_blurb": "Welcome to Chardonnay in Tulsa, where vibrant living meets convenience! Choose from inviting one- and two-bedroom floor plans, and dive into a world of activities nearby. From the Oklahoma Aquarium to Corporate Offices, parks, and educational institutions, your new home is a hub of excitement and exploration. ",
  "property_home_reviews_blurb": "At Chardonnay in Tulsa, Oklahoma, residents are thrilled with their homes, noting, \"The property manager is great, and the maintenance team are always helpful and friendly!\" Experience the welcoming atmosphere that our community offers. See what our residents have to say about living at Chardonnay!",
  "property_neighborhood_blurb": "Nestled in the heart of Tulsa, Chardonnay offers more than just exquisite one- and two-bedroom floor plans. Immerse yourself in a vibrant neighborhood featuring top-notch attractions like the Oklahoma Aquarium, Urban Air Trampoline Park, and the serene LaFortune Park. Experience the perfect balance of comfort and convenience right at your doorstep.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Chardonnay in Tulsa, experience a lifestyle of comfort and convenience. Our one and two-bedroom apartments boast spacious floor plans, high-speed internet, and modern kitchens. Enjoy the sparkling pool, clubhouse, and pet-friendly courtyard. Dive into relaxation and community living—discover your new home today!",
  "property_applynow_blurb": "Welcome to Chardonnay in Tulsa, where modern living meets comfort. Choose from airy one and two-bedroom floor plans featuring walk-in closets and spacious balconies. Dive into relaxation at our sparkling pool, work in style at the business center, or unwind in the pet-friendly courtyard. Lease your dream home online today!",
  "property_contactus_blurb": "At Chardonnay in Tulsa, Oklahoma, you’ll find the perfect floor plan to match your lifestyle, whether it’s a cozy one-bedroom retreat or a spacious two-bedroom sanctuary. Our dedicated leasing team is here to assist you—reach out today to learn more about your future home!",
  "property_faqs_blurb": "At Chardonnay in Tulsa, Oklahoma, you’ll find thoughtfully designed one and two-bedroom floor plans that cater to your lifestyle. Have questions? Our FAQs page provides all the answers, ensuring you’re well-informed about our vibrant community and amenities. Dive in to learn more about your future home!",
  "property_floorplans_blurb": "At Chardonnay in Tulsa, Oklahoma, your ideal living space awaits. With thoughtfully designed one and two-bedroom floor plans, each home is crafted for comfort and style. Uncover the perfect blend of elegance and practicality—browse our available apartment homes today and envision your new lifestyle at Chardonnay!",
  "property_gallery_blurb": "At Chardonnay in Tulsa, your dream home awaits with thoughtfully designed one- and two-bedroom floor plans. Indulge in amenities like a shimmering pool, a cozy clubhouse, and a vibrant pet play area. Picture yourself living here, surrounded by luxury and comfort that elevate your lifestyle to new heights!",
  "property_interactivemap_blurb": "Welcome to Chardonnay, where comfort meets convenience in Tulsa, Oklahoma. Choose from spacious one and two-bedroom floor plans packed with modern amenities. Take a dip in the pool, unwind at the clubhouse, or enjoy the pet play area. Use our interactive map to find your perfect new home today!",
  "property_pets_blurb": "At Chardonnay in Tulsa, OK, your furry friends are part of the family! Enjoy spacious living with a pet-friendly atmosphere, allowing up to two pets per unit. Revel in the nearby parks and trails, perfect for weekend adventures. Your companion’s comfort starts here, where home meets heart!",
  "property_referafriend_blurb": "At Chardonnay in Tulsa, Oklahoma, your ideal living space awaits! Choose from our inviting one and two-bedroom floor plans, perfect for cozy living or sharing life’s moments. Great friends make great neighbors—refer a friend to our community today and enhance your living experience together!",
  "property_residentaccess_blurb": "Welcome to Chardonnay, your serene Tulsa haven! Whether you choose a cozy one-bedroom or spacious two-bedroom apartment, enjoy modern living at its finest. Access your resident portal to effortlessly pay rent, schedule maintenance, and stay connected to your community. Elevate your lifestyle today at Chardonnay!",
  "property_reviews_blurb": "At Chardonnay in Tulsa, Oklahoma, residents rave about their homes, highlighting the “great” property management and always “helpful and friendly” maintenance team. Join a community where your comfort is our priority. See what our residents have to say about living at our community!",
  "property_created_at": "1753982379621",
  "property_scheduletour_blurb": "At Chardonnay in Tulsa, Oklahoma, our thoughtfully designed one- and two-bedroom floor plans cater to your lifestyle. Experience the charm of our vibrant community and imagine yourself enjoying spacious living. Don’t just take our word for it; check out what our residents say about calling this place home! Schedule your tour today!",
  "property_thankyou_blurb": "Thank you for reaching out to Chardonnay, where modern living meets timeless elegance in Tulsa, Oklahoma. With thoughtfully designed one and two-bedroom floor plans, your dream home awaits. A team member will be in touch soon to guide you toward your ideal lifestyle in our vibrant community.",
  "property_virtualtours_blurb": "Welcome to Chardonnay in Tulsa, Oklahoma, where modern living meets comfort. Choose from our thoughtfully designed one and two-bedroom floor plans tailored for your lifestyle. Experience our vibrant community firsthand—take a virtual tour today and envision your new home coming to life!",
  "property_copyright": "2025 All Rights Reserved. Chardonnay",
  "property_seo_title_home": "Chardonnay |  Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Discover vibrant living at Chardonnay in Tulsa! Enjoy spacious layouts, great amenities, and a pet-friendly vibe. Find your new home today!",
  "property_seo_title_floorplans": "Floor Plans | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal space at Chardonnay in Tulsa! Browse our unique one and two-bedroom floor plans, designed for comfort and style. Your perfect home awaits!",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience life at Chardonnay in Tulsa—where modern amenities meet comfort. Enjoy our pool, clubhouse, and spacious layouts. Your perfect home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "Picture your life at Chardonnay in Tulsa! Relax by the pool, unwind on your patio, and enjoy modern comforts in spacious floor plans. Your dream home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Chardonnay Apartments",
  "property_seo_description_virtualtours": "Experience Chardonnay in Tulsa—your new home awaits! Take a virtual tour to explore our stylish one and two-bedroom apartments. See it to believe it!",
  "property_seo_title_interactivemap": "Interactive Map | Chardonnay Apartments",
  "property_seo_description_interactivemap": "Uncover your perfect home at Chardonnay in Tulsa! Use our interactive map to find spacious floor plans, luxury amenities, and your dream lifestyle today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Experience life at Chardonnay in Tulsa! Uncover local favorites and nearby gems that make our vibrant neighborhood the perfect place to call home.",
  "property_seo_title_contact": "Contact Us | Chardonnay",
  "property_seo_description_contact": "Discover your ideal space at Chardonnay, Tulsa! Choose a cozy one-bedroom or roomy two-bedroom. Contact our leasing team today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Find answers to your questions about Chardonnay in Tulsa! Learn about our one- and two-bedroom apartments filled with luxurious amenities and community perks.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Join the lively Chardonnay community in Tulsa! Explore resident reviews and enjoy top amenities like a pool, clubhouse, and pet-friendly areas.",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Discover luxury at Chardonnay in Tulsa! Spacious one and two-bedroom apartments with premium amenities. Apply online for your dream home today!",
  "property_seo_title_residentaccess": "Resident Access | Chardonnay",
  "property_seo_description_residentaccess": "Log in to your Chardonnay resident portal for hassle-free rent payments, maintenance requests, and exclusive community updates. Your convenience awaits!",
  "property_seo_title_referafriend": "Refer A Friend | Chardonnay",
  "property_seo_description_referafriend": "Refer a friend to Chardonnay in Tulsa! Enjoy vibrant living, exceptional amenities, and a community where great friends become great neighbors. Join us today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Chardonnay",
  "property_seo_description_scheduletour": "Experience luxury living at Chardonnay in Tulsa! Schedule your tour today and unveil your future home in a vibrant community that blends comfort and style.",
  "property_seo_title_privacy": "Privacy Policy | Chardonnay",
  "property_seo_description_privacy": "At Chardonnay in Tulsa, your privacy is paramount. Dive into our policy to understand how we protect your information while you enjoy your vibrant community.",
  "property_seo_title_accessibility": "Website Accessibility | Chardonnay",
  "property_seo_description_accessibility": "At Chardonnay in Tulsa, we champion accessibility for all. Experience inclusive living with our commitment to digital inclusion—everyone is welcome here!",
  "property_seo_title_sitemap": "Sitemap | Chardonnay",
  "property_seo_description_sitemap": "Unveil the charm of Chardonnay in Tulsa, where modern living meets comfort. Navigate our sitemap to find your perfect home and amenities tailored for you.",
  "property_seo_title_thankyou": "Thank You | Chardonnay",
  "property_seo_description_thankyou": "Thank you for your interest in Chardonnay Apartments! Our team will reach out soon to assist with your apartment journey.",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864951803",
  "amenities": [
    {
      "id": "ec_dc6f3426e1bc98c90742e8f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127396325",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fea9d46e043b1c896ad965fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127396327",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6dbcab5e67882089411a7e3f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127396328",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_497cab65e31ca9bdf51d7e96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127396329",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9904f871481f5a212320f93c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127396330",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_53aa6beb9d78ab3946113bdc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127396331",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_46835f068b85f0d44114e3c3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127396332",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e1af5ee16c7e65e146fe8d7b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127396333",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e316d30d1658a9de6d320011",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "128017309",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b4ed3bed8f7a7f7e5af07a53",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127397835",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_40c30378649bdd9e8bff491b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127397837",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f1efc9e74a29ab82cd6fc49a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127397838",
      "title": "Fireplace",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d9136fab5bd1c684356961bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127397839",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5c0390aaa5110a820ed4c96b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127397840",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_7711673245c6285b2b224b26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127397841",
      "title": "Washer/Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c2d9d7027147f8b33ba2c815",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127397842",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_42268ebfe314126fffa11c55",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "yardi",
      "external_id": "127397843",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4e215318-7dce-40e0-9388-e112f1b8a72d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7d-28ba-763a-abcb-6c224fbeca00.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment like a tunnel, jumping bars, and weave poles.",
        "public_id": "019dcf7d-28ba-763a-abcb-6c224fbeca00",
        "storage_key": "property/6767906449165591/019dcf7d-28ba-763a-abcb-6c224fbeca00.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Your furry friends will love our on-site dog park, complete with fun agility equipment to keep them entertained and active.",
      "link": "",
      "alt_text": "A fenced-in dog park with agility equipment like a tunnel, jumping bars, and weave poles.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5de9d6ae-392b-4e23-8279-fac8632b3df6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7d-064c-704b-a04e-50f0bf7a54f3.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with a red tunnel and benches under a blue sky.",
        "public_id": "019dcf7d-064c-704b-a04e-50f0bf7a54f3",
        "storage_key": "property/6767906449165591/019dcf7d-064c-704b-a04e-50f0bf7a54f3.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy our on-site dog park, complete with tunnels and ample space for your furry friends to play and socialize.",
      "link": "",
      "alt_text": "A fenced-in dog park with a red tunnel and benches under a blue sky.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_647042de-3f06-46af-a583-afc5f428f1b4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-fd6c-74ee-a798-a942d8340c03.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment building entrance with lush landscaping and reserved parking sign.",
        "public_id": "019dcf7c-fd6c-74ee-a798-a942d8340c03",
        "storage_key": "property/6767906449165591/019dcf7c-fd6c-74ee-a798-a942d8340c03.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring well-maintained grounds, a colorful flowering tree, and convenient reserved parking.",
      "link": "",
      "alt_text": "Exterior view of apartment building entrance with lush landscaping and reserved parking sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c1f9d986-3843-4c7f-a557-6a001f784bef",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-f7d3-74bd-a6e6-15d3a07cee62.webp",
      "image_media": {
        "alt_text": "Chardonnay Apartment Homes monument sign and building exterior with American flag.",
        "public_id": "019dcf7c-f7d3-74bd-a6e6-15d3a07cee62",
        "storage_key": "property/6767906449165591/019dcf7c-f7d3-74bd-a6e6-15d3a07cee62.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Chardonnay Apartment Homes, featuring a beautifully landscaped entrance with a prominent monument sign and attractive building exteriors.",
      "link": "",
      "alt_text": "Chardonnay Apartment Homes monument sign and building exterior with American flag.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c53c54d5-ff81-4225-9bb9-e507f373b89b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-f2a4-72ce-bd69-80e05de75090.webp",
      "image_media": {
        "alt_text": "Outdoor dining area with grill and patio furniture near a swimming pool.",
        "public_id": "019dcf7c-f2a4-72ce-bd69-80e05de75090",
        "storage_key": "property/6767906449165591/019dcf7c-f2a4-72ce-bd69-80e05de75090.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy outdoor living with our community grilling station and patio seating, perfect for relaxing by the pool.",
      "link": "",
      "alt_text": "Outdoor dining area with grill and patio furniture near a swimming pool.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f31ed79c-ecfb-449a-af0e-24fba8098d77",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-eef6-739a-9803-0561819c5076.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and seating areas under umbrellas.",
        "public_id": "019dcf7c-eef6-739a-9803-0561819c5076",
        "storage_key": "property/6767906449165591/019dcf7c-eef6-739a-9803-0561819c5076.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded seating areas.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and seating areas under umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c0661378-b413-4ec6-930a-1d73bb313b05",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-eac3-746f-a4cb-51ecb3608e07.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
        "public_id": "019dcf7c-eac3-746f-a4cb-51ecb3608e07",
        "storage_key": "property/6767906449165591/019dcf7c-eac3-746f-a4cb-51ecb3608e07.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool, surrounded by lush landscaping and comfortable lounge chairs. Perfect for relaxing and unwinding.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and surrounding apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6291926d-b3d5-4265-9f49-7b8fe26e07d5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-ea78-73be-b7e1-25421a081928.webp",
      "image_media": {
        "alt_text": "Apartment complex swimming pool and spa with lounge chairs and umbrellas.",
        "public_id": "019dcf7c-ea78-73be-b7e1-25421a081928",
        "storage_key": "property/6767906449165591/019dcf7c-ea78-73be-b7e1-25421a081928.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool and relaxing spa, surrounded by lush landscaping and comfortable lounge seating.",
      "link": "",
      "alt_text": "Apartment complex swimming pool and spa with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e8de1b19-b601-41ec-9b07-73b0c64eb2a1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-d8b3-7268-bb4d-0a751c182d93.webp",
      "image_media": {
        "alt_text": "A paved walkway leads through a grassy courtyard with manicured flower beds between apartment buildings.",
        "public_id": "019dcf7c-d8b3-7268-bb4d-0a751c182d93",
        "storage_key": "property/6767906449165591/019dcf7c-d8b3-7268-bb4d-0a751c182d93.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stroll through the beautifully landscaped courtyards, featuring vibrant flower beds and lush green lawns, connecting the apartment buildings.",
      "link": "",
      "alt_text": "A paved walkway leads through a grassy courtyard with manicured flower beds between apartment buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_87d0ed54-b45b-44ed-b2db-b39c3b1f5fc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-d3ff-753f-a5f4-96c66055f404.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and walkways.",
        "public_id": "019dcf7c-d3ff-753f-a5f4-96c66055f404",
        "storage_key": "property/6767906449165591/019dcf7c-d3ff-753f-a5f4-96c66055f404.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "View of apartment building exteriors featuring balconies, walkways, and manicured landscaping.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and walkways.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0a895d67-09be-4d86-ad47-ce221f034d42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-d0a4-708b-9ada-fb09cf4c6c09.webp",
      "image_media": {
        "alt_text": "Chardonnay Apartment Homes monument sign",
        "public_id": "019dcf7c-d0a4-708b-9ada-fb09cf4c6c09",
        "storage_key": "property/6767906449165591/019dcf7c-d0a4-708b-9ada-fb09cf4c6c09.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to Chardonnay Apartment Homes. This monument sign is located at the entrance of the community.",
      "link": "",
      "alt_text": "Chardonnay Apartment Homes monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_34c11f9d-7342-428e-8ec2-28fd8038f324",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-cab4-72a0-911e-0c54dc0fd54b.webp",
      "image_media": {
        "alt_text": "Apartment building exterior with stone accents and manicured landscaping.",
        "public_id": "019dcf7c-cab4-72a0-911e-0c54dc0fd54b",
        "storage_key": "property/6767906449165591/019dcf7c-cab4-72a0-911e-0c54dc0fd54b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Charming apartment building exterior featuring a welcoming entrance with stone pillars and vibrant flower beds, surrounded by lush green lawns.",
      "link": "",
      "alt_text": "Apartment building exterior with stone accents and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_248572ec-5bee-49ec-920b-aab9559bf5dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-ca1b-7038-b165-dcda26d04c41.webp",
      "image_media": {
        "alt_text": "Apartment building entrance with stone facade and arched entryway.",
        "public_id": "019dcf7c-ca1b-7038-b165-dcda26d04c41",
        "storage_key": "property/6767906449165591/019dcf7c-ca1b-7038-b165-dcda26d04c41.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our apartment community, featuring a beautifully landscaped entrance and building exterior. Experience comfortable living.",
      "link": "",
      "alt_text": "Apartment building entrance with stone facade and arched entryway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_cdfbbf4b-029f-4e06-a64d-13d146ec1217",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-8f36-77ce-9f2a-14c3b9aede2a.webp",
      "image_media": {
        "alt_text": "Cozy lounge area with a large sectional sofa, stone fireplace, and large windows overlooking the grounds.",
        "public_id": "019dcf7c-8f36-77ce-9f2a-14c3b9aede2a",
        "storage_key": "property/6767906449165591/019dcf7c-8f36-77ce-9f2a-14c3b9aede2a.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting resident lounge, featuring a warm fireplace and comfortable seating. Perfect for socializing or enjoying a quiet moment.",
      "link": "",
      "alt_text": "Cozy lounge area with a large sectional sofa, stone fireplace, and large windows overlooking the grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_51bd761f-1b83-48f6-9aa2-20f3df767c07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-8f2d-7460-abfd-86e2338b4b0b.webp",
      "image_media": {
        "alt_text": "Reception desk with computer and printer, view of pool area through glass doors.",
        "public_id": "019dcf7c-8f2d-7460-abfd-86e2338b4b0b",
        "storage_key": "property/6767906449165591/019dcf7c-8f2d-7460-abfd-86e2338b4b0b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Welcome to our community's reception area, featuring a desk with amenities and a glimpse of the inviting pool outside.",
      "link": "",
      "alt_text": "Reception desk with computer and printer, view of pool area through glass doors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_11c6bb0d-d38b-422e-b5c0-8978930da1d4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-8d47-74bf-898a-e4e0a3a01b48.webp",
      "image_media": {
        "alt_text": "Building entrance with double doors and windows, and a welcome sign.",
        "public_id": "019dcf7c-8d47-74bf-898a-e4e0a3a01b48",
        "storage_key": "property/6767906449165591/019dcf7c-8d47-74bf-898a-e4e0a3a01b48.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "The welcoming entrance of the building features double wooden doors and large windows, with a decorative sign at the front.",
      "link": "",
      "alt_text": "Building entrance with double doors and windows, and a welcome sign.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b1f04e15-6d12-4f32-862b-ba21bd53e326",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-3961-75e9-a0cb-fdb75f6a2975.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with sink and mirror, toilet, and bathtub with shower curtain.",
        "public_id": "019dcf7c-3961-75e9-a0cb-fdb75f6a2975",
        "storage_key": "property/6767906449165591/019dcf7c-3961-75e9-a0cb-fdb75f6a2975.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Apartment",
      "description": "Discover a well-appointed bathroom featuring a modern vanity with a sink and ample counter space, a convenient toilet, and a bathtub with a stylish shower curtain.",
      "link": "",
      "alt_text": "Bathroom vanity with sink and mirror, toilet, and bathtub with shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_99c4111a-6f87-4f86-8f19-9b5209668418",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-36d3-7618-8cd3-129f7ce5817c.webp",
      "image_media": {
        "alt_text": "Living room with a gray sofa, throw blankets, and a television on a console table.",
        "public_id": "019dcf7c-36d3-7618-8cd3-129f7ce5817c",
        "storage_key": "property/6767906449165591/019dcf7c-36d3-7618-8cd3-129f7ce5817c.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this comfortable living space, featuring a plush sofa and modern entertainment center.",
      "link": "",
      "alt_text": "Living room with a gray sofa, throw blankets, and a television on a console table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_daa1ee96-2ae2-43af-8588-84bfcb82560f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-3c9d-76e8-94cb-f77787979815.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a wooden bed frame, plush pillows, and a bedside table with a lamp.",
        "public_id": "019dcf7c-3c9d-76e8-94cb-f77787979815",
        "storage_key": "property/6767906449165591/019dcf7c-3c9d-76e8-94cb-f77787979815.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in this inviting bedroom, featuring a comfortable bed, stylish decor, and ample natural light. Perfect for unwinding after a long day.",
      "link": "",
      "alt_text": "Cozy bedroom with a wooden bed frame, plush pillows, and a bedside table with a lamp.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f9b4107d-f82a-4e55-b743-e4e93aa7b5b2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-3d39-72ae-a1b0-2c21fd175d92.webp",
      "image_media": {
        "alt_text": "Kitchen with wood cabinets, white countertops, stainless steel sink, and white appliances including a stove and refrigerator.",
        "public_id": "019dcf7c-3d39-72ae-a1b0-2c21fd175d92",
        "storage_key": "property/6767906449165591/019dcf7c-3d39-72ae-a1b0-2c21fd175d92.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A functional and tidy kitchen featuring ample cabinet space, a double-basin sink, and a full suite of essential appliances.",
      "link": "",
      "alt_text": "Kitchen with wood cabinets, white countertops, stainless steel sink, and white appliances including a stove and refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_9412f5f7-ff8b-4624-bb7a-e39504914109",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-24da-71cc-a208-5482e036ecad.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances, wooden cabinets, and a sink area.",
        "public_id": "019dcf7c-24da-71cc-a208-5482e036ecad",
        "storage_key": "property/6767906449165591/019dcf7c-24da-71cc-a208-5482e036ecad.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Explore this spacious kitchen featuring white appliances, ample wooden cabinetry, and a functional sink area, perfect for your culinary needs.",
      "link": "",
      "alt_text": "Kitchen with white appliances, wooden cabinets, and a sink area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d1d31be0-cedb-4d37-a43d-68b73ef6cfec",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-0b74-71c9-a701-ad9e49e6662c.webp",
      "image_media": {
        "alt_text": "Walk-in closet with shelves and hanging rod",
        "public_id": "019dcf7c-0b74-71c9-a701-ad9e49e6662c",
        "storage_key": "property/6767906449165591/019dcf7c-0b74-71c9-a701-ad9e49e6662c.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet offering ample storage with built-in shelves and a hanging rod.",
      "link": "",
      "alt_text": "Walk-in closet with shelves and hanging rod",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f85790c4-ba19-4c08-bc78-d401fe3687e3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-120b-7351-a2fd-d476804d8254.webp",
      "image_media": {
        "alt_text": "Living room fireplace with modern art above and sofa to the side.",
        "public_id": "019dcf7c-120b-7351-a2fd-d476804d8254",
        "storage_key": "property/6767906449165591/019dcf7c-120b-7351-a2fd-d476804d8254.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace with a tiled hearth, modern abstract art, and a comfortable sofa with plush pillows and throws.",
      "link": "",
      "alt_text": "Living room fireplace with modern art above and sofa to the side.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b737cf64-bb1b-4842-bb1f-dba1a7ec3cc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-fdb5-745d-b21e-f39d02300dfe.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed and blue bedding, bedside tables, and decor.",
        "public_id": "019dcf7b-fdb5-745d-b21e-f39d02300dfe",
        "storage_key": "property/6767906449165591/019dcf7b-fdb5-745d-b21e-f39d02300dfe.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom, featuring a queen-size bed, elegant bedside tables, and tasteful decor.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed and blue bedding, bedside tables, and decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_d8a65d28-3717-446b-ba78-f44175d61465",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-0a49-7284-922f-5a6675a87459.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and kitchen counter with stools.",
        "public_id": "019dcf7c-0a49-7284-922f-5a6675a87459",
        "storage_key": "property/6767906449165591/019dcf7c-0a49-7284-922f-5a6675a87459.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living area featuring a fireplace, and a kitchen counter with modern stools. Perfect for entertaining or relaxing.",
      "link": "",
      "alt_text": "Living room with fireplace and kitchen counter with stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_f260b98d-8f28-412b-8a1a-602bbdacccdd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-0c3f-7088-8fb6-a5c03dbeb9e3.webp",
      "image_media": {
        "alt_text": "Modern bathroom with navy blue towels, abstract wall art, and a white vanity.",
        "public_id": "019dcf7c-0c3f-7088-8fb6-a5c03dbeb9e3",
        "storage_key": "property/6767906449165591/019dcf7c-0c3f-7088-8fb6-a5c03dbeb9e3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Refresh and unwind in this stylish bathroom, featuring crisp navy blue towels, contemporary wall decor, and a clean white vanity.",
      "link": "",
      "alt_text": "Modern bathroom with navy blue towels, abstract wall art, and a white vanity.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_358f20c4-d7dd-4a69-9f70-788d2f8932f0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-f705-748e-aaa4-548d2df0d9d4.webp",
      "image_media": {
        "alt_text": "Updated kitchen with white appliances, wood cabinets, and laminate flooring.",
        "public_id": "019dcf7b-f705-748e-aaa4-548d2df0d9d4",
        "storage_key": "property/6767906449165591/019dcf7b-f705-748e-aaa4-548d2df0d9d4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and updated kitchen featuring white appliances, ample cabinet space, and modern laminate flooring for a clean and functional cooking experience.",
      "link": "",
      "alt_text": "Updated kitchen with white appliances, wood cabinets, and laminate flooring.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b97f94dd-42d5-4137-9506-ca24c4ddd9ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-f5aa-72c8-ba4f-1a6774ba3d14.webp",
      "image_media": {
        "alt_text": "Kitchen with white appliances including a microwave, oven, and refrigerator, alongside wooden cabinetry and a white countertop.",
        "public_id": "019dcf7b-f5aa-72c8-ba4f-1a6774ba3d14",
        "storage_key": "property/6767906449165591/019dcf7b-f5aa-72c8-ba4f-1a6774ba3d14.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A well-lit kitchen featuring white appliances, ample wooden cabinetry, and a spacious white countertop, perfect for meal preparation.",
      "link": "",
      "alt_text": "Kitchen with white appliances including a microwave, oven, and refrigerator, alongside wooden cabinetry and a white countertop.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6b8aeb46-d176-4bea-9b02-d60ab6872871",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7c-04c8-709a-b9fc-5cfea208149a.webp",
      "image_media": {
        "alt_text": "View of the apartment complex grounds and swimming pool from a balcony.",
        "public_id": "019dcf7c-04c8-709a-b9fc-5cfea208149a",
        "storage_key": "property/6767906449165591/019dcf7c-04c8-709a-b9fc-5cfea208149a.webp",
        "width": 3072,
        "height": 2049
      },
      "title": "Community",
      "description": "Enjoy the outdoors with a view of the community pool and lush landscaping from your private balcony.",
      "link": "",
      "alt_text": "View of the apartment complex grounds and swimming pool from a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b9d127c1-b96a-43e3-a292-379d9c4cbf26",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-e1c8-71e6-b755-a06798947517.webp",
      "image_media": {
        "alt_text": "Dining area with round table and four chairs",
        "public_id": "019dcf7b-e1c8-71e6-b755-a06798947517",
        "storage_key": "property/6767906449165591/019dcf7b-e1c8-71e6-b755-a06798947517.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy dining area featuring a round table with four upholstered chairs, perfect for intimate meals or gathering with friends. Decorated with unique wall art.",
      "link": "",
      "alt_text": "Dining area with round table and four chairs",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c859a815-7bc3-4d81-a7c6-6ed80383df59",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-e119-73aa-89ad-6b3de90cfd63.webp",
      "image_media": {
        "alt_text": "Living room with a large television, entertainment center, fireplace, and a white curved sofa.",
        "public_id": "019dcf7b-e119-73aa-89ad-6b3de90cfd63",
        "storage_key": "property/6767906449165591/019dcf7b-e119-73aa-89ad-6b3de90cfd63.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a large TV, modern entertainment center, cozy fireplace, and a comfortable white sofa, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with a large television, entertainment center, fireplace, and a white curved sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_24429d1d-62fc-4dc3-9ffb-ce25c150be12",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-e11b-7743-a789-e804a57cbba9.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstand with lamp, and blue curtains.",
        "public_id": "019dcf7b-e11b-7743-a789-e804a57cbba9",
        "storage_key": "property/6767906449165591/019dcf7b-e11b-7743-a789-e804a57cbba9.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax in comfort in this beautifully appointed bedroom. Featuring a plush queen-size bed, a stylish nightstand with a lamp, and serene blue curtains.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed, nightstand with lamp, and blue curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6e9f5617-b795-47c0-bdaf-73c9f598cb0a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-e119-73aa-89ad-677005680d7e.webp",
      "image_media": {
        "alt_text": "Kitchen area with dining table and bar stools.",
        "public_id": "019dcf7b-e119-73aa-89ad-677005680d7e",
        "storage_key": "property/6767906449165591/019dcf7b-e119-73aa-89ad-677005680d7e.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern kitchen and dining area featuring a breakfast bar with bar stools, a dining table with chairs, and decorative wall art.",
      "link": "",
      "alt_text": "Kitchen area with dining table and bar stools.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ac2fa3c1-ced6-4e2b-9146-565e1ea82214",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-e115-769f-9af3-aa3d1f7bc189.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and dining area.",
        "public_id": "019dcf7b-e115-769f-9af3-aa3d1f7bc189",
        "storage_key": "property/6767906449165591/019dcf7b-e115-769f-9af3-aa3d1f7bc189.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace and a dining area, perfect for relaxation and entertaining.",
      "link": "",
      "alt_text": "Living room with a fireplace, coffee table, and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_750f7870-25f2-4ddd-8640-9ed2f7c65ef3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-c8ee-732b-9153-15f90ebbb054.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, modern sofa, armchair, and coffee table.",
        "public_id": "019dcf7b-c8ee-732b-9153-15f90ebbb054",
        "storage_key": "property/6767906449165591/019dcf7b-c8ee-732b-9153-15f90ebbb054.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a gas fireplace, a stylish sofa and armchair, perfect for relaxing evenings.",
      "link": "",
      "alt_text": "Living room with a fireplace, modern sofa, armchair, and coffee table.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_63032395-3e5c-4acb-ac62-e61afad51566",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019dcf7b-cdba-76de-98d5-8c66270e3aa7.webp",
      "image_media": {
        "alt_text": "View of the outdoor swimming pool and clubhouse area from a balcony.",
        "public_id": "019dcf7b-cdba-76de-98d5-8c66270e3aa7",
        "storage_key": "property/6767906449165591/019dcf7b-cdba-76de-98d5-8c66270e3aa7.webp",
        "width": 3072,
        "height": 2047
      },
      "title": "Community",
      "description": "Enjoy our resort-style swimming pool and beautifully landscaped grounds. Perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "View of the outdoor swimming pool and clubhouse area from a balcony.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_d5c0f86d-02af-4f17-b5f8-45ff35c3689e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-1ff6-74ce-b677-1c505ef537d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1ff6-74ce-b677-1c505ef537d5",
        "storage_key": "property/6767906449165591/019cfb3b-1ff6-74ce-b677-1c505ef537d5.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_aec9a4f3-4d7d-4cd0-88aa-d2448091f6e4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2038-766b-9765-613fb2602340.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2038-766b-9765-613fb2602340",
        "storage_key": "property/6767906449165591/019cfb3b-2038-766b-9765-613fb2602340.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_0ca53524-d8c2-4279-a33d-ff362e4358db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-1ee0-777a-bc3c-2531b9332adc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1ee0-777a-bc3c-2531b9332adc",
        "storage_key": "property/6767906449165591/019cfb3b-1ee0-777a-bc3c-2531b9332adc.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_20dfb96c-0ab5-4e20-93d8-c95da6ca1abe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Popular fast-food chain specializing in chicken sandwiches and nuggets.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-1ea8-775b-800c-da81ebc78f62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1ea8-775b-800c-da81ebc78f62",
        "storage_key": "property/6767906449165591/019cfb3b-1ea8-775b-800c-da81ebc78f62.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_796784d3-5d39-4a83-a134-f979f760eecf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-1ffd-725c-b1f4-a2a9e2f8d33b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1ffd-725c-b1f4-a2a9e2f8d33b",
        "storage_key": "property/6767906449165591/019cfb3b-1ffd-725c-b1f4-a2a9e2f8d33b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_161cc9fb-bcad-4e35-a942-ad15f123551d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-1ff9-74e4-aee9-4400857b7f10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1ff9-74e4-aee9-4400857b7f10",
        "storage_key": "property/6767906449165591/019cfb3b-1ff9-74e4-aee9-4400857b7f10.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_b3d249d0-dcec-4bf7-a9f3-5ca3cb849bcc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and discounts. They highlight the clean, spacious, and welcoming atmosphere, as well as the convenient layout and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-20ff-72d1-bb0f-9663c8e1c702.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-20ff-72d1-bb0f-9663c8e1c702",
        "storage_key": "property/6767906449165591/019cfb3b-20ff-72d1-bb0f-9663c8e1c702.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_80341e1b-28d5-41d4-ba8f-3cd08ab2ee61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2006-71bc-9acb-cdcd1fa4857b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2006-71bc-9acb-cdcd1fa4857b",
        "storage_key": "property/6767906449165591/019cfb3b-2006-71bc-9acb-cdcd1fa4857b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d6-7735-bd3f-634ca37f4aef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d6-7735-bd3f-634ca37f4aef",
        "storage_key": "property/6767906449165591/019cfb3b-32d6-7735-bd3f-634ca37f4aef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_acf59682-b068-4ea9-81d7-614d8170b4bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-1f16-761f-9005-c7179b1f69e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1f16-761f-9005-c7179b1f69e4",
        "storage_key": "property/6767906449165591/019cfb3b-1f16-761f-9005-c7179b1f69e4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d6-7735-bd3f-634ca37f4aef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d6-7735-bd3f-634ca37f4aef",
        "storage_key": "property/6767906449165591/019cfb3b-32d6-7735-bd3f-634ca37f4aef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_1d255c21-d90f-453e-85f3-07f62747fbcb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9136 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Market selling organic produce and gluten-free grocery items.",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy and organic foods, including fresh produce, a salad bar, and a variety of vitamins and supplements. They also highlight the clean and organized layout, the friendly and helpful staff, and the relaxed shopping experience.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-1ffd-725c-b1f4-a405e04d95ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-1ffd-725c-b1f4-a405e04d95ab",
        "storage_key": "property/6767906449165591/019cfb3b-1ffd-725c-b1f4-a405e04d95ab.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/yale?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690334156598386947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.030638",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-879-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d6-7735-bd3f-634ca37f4aef.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d6-7735-bd3f-634ca37f4aef",
        "storage_key": "property/6767906449165591/019cfb3b-32d6-7735-bd3f-634ca37f4aef.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2KYkCCStocRA6HtoRBqF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_ddb74d00-9c65-4e41-9a90-e337a3e5dbec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-22e1-749f-a942-79b39b264002.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-22e1-749f-a942-79b39b264002",
        "storage_key": "property/6767906449165591/019cfb3b-22e1-749f-a942-79b39b264002.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 8 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_217a561e-909e-408a-bc39-c054345d94a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-22ca-7164-b6c4-041e9356dbf5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-22ca-7164-b6c4-041e9356dbf5",
        "storage_key": "property/6767906449165591/019cfb3b-22ca-7164-b6c4-041e9356dbf5.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_53fb2393-860c-4fa1-bc2f-e78c44166315",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-22e1-749f-a942-7d4908c68651.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-22e1-749f-a942-7d4908c68651",
        "storage_key": "property/6767906449165591/019cfb3b-22e1-749f-a942-7d4908c68651.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_c928cd7a-c7ea-42b5-a8ac-744e29323fb9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-245b-751b-a204-c66a05bc30a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-245b-751b-a204-c66a05bc30a2",
        "storage_key": "property/6767906449165591/019cfb3b-245b-751b-a204-c66a05bc30a2.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 6 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_80e92d5a-dfb3-45f3-9dec-36f82c0ee1f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Relaxed aquarium with sharks, river otters, turtles and jellyfish.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-245f-75c3-9686-4c241fb0bb87.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-245f-75c3-9686-4c241fb0bb87",
        "storage_key": "property/6767906449165591/019cfb3b-245f-75c3-9686-4c241fb0bb87.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 40 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_aeae8b2a-06e0-4508-b8c3-256ebe4ad936",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2475-7643-847d-b07b2b28683c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2475-7643-847d-b07b2b28683c",
        "storage_key": "property/6767906449165591/019cfb3b-2475-7643-847d-b07b2b28683c.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_faca0d6f-6c06-4cfa-abb0-160bb246d495",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2586-705f-b738-406e55d4a7a5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2586-705f-b738-406e55d4a7a5",
        "storage_key": "property/6767906449165591/019cfb3b-2586-705f-b738-406e55d4a7a5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_af163d00-abcf-4981-91ed-955d2c531fef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2489-702b-adb6-676a700ce3b7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2489-702b-adb6-676a700ce3b7",
        "storage_key": "property/6767906449165591/019cfb3b-2489-702b-adb6-676a700ce3b7.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_18488a38-147d-41cb-8957-77c13696768b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Golden Driller Statue",
      "poi_type": "Entertainment",
      "poi_address": "Tulsa Expo Center, 4145 E 21st St, Tulsa, OK 74114, USA",
      "poi_short_description": "Golden, roadside landmark, built in 1953 in Tulsa, of an oil worker (nicknamed “the Driller”), 75 feet tall, adorned with a T-shirt, representing a time when the town was known as the “oil capital of the world”.",
      "poi_long_description": "Visitors say this historical landmark is a must-see, especially for those from out of town, and they praise the statue's impressive size. They also highlight that parking is free and it's a great place to stop for photos, especially during events like the Tulsa State Fair.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-251f-7269-9661-cbea34800af3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-251f-7269-9661-cbea34800af3",
        "storage_key": "property/6767906449165591/019cfb3b-251f-7269-9661-cbea34800af3.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://exposquare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14322764790652212651&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "golden-driller-statue",
      "poi_latitude": "36.1337734",
      "poi_longitude": "-95.9311081",
      "poi_miles_from_property": "8.1",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-596-2100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJswh6RCPttocRqxVMHLGuxMY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "historical_landmark"
    },
    {
      "id": "custom_f90520e8-ac0a-48b0-8eec-9af9c590e454",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-257e-7659-9065-5d6a41cce2fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-257e-7659-9065-5d6a41cce2fa",
        "storage_key": "property/6767906449165591/019cfb3b-257e-7659-9065-5d6a41cce2fa.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_8b0efdf8-6532-4569-a6fd-ab355aa4761a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2726-744f-b3b0-cd8fb804ce79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2726-744f-b3b0-cd8fb804ce79",
        "storage_key": "property/6767906449165591/019cfb3b-2726-744f-b3b0-cd8fb804ce79.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_a045ff9e-9906-425e-92bf-d52c565fc5d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2773-735c-bfd9-9d787fb20cf3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2773-735c-bfd9-9d787fb20cf3",
        "storage_key": "property/6767906449165591/019cfb3b-2773-735c-bfd9-9d787fb20cf3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_32cf8d2d-ffef-4d37-a4ed-d71c263bc131",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "Gym goers say this gym offers a clean and tidy facility with a welcoming and judgement-free atmosphere, and they appreciate the friendly and helpful staff. They also highlight the great price and smooth interaction with other members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-26b2-72d2-a92c-696143559430.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-26b2-72d2-a92c-696143559430",
        "storage_key": "property/6767906449165591/019cfb3b-26b2-72d2-a92c-696143559430.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_3ad56f72-8822-45d3-b841-bc082ced50e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "iidentity salon",
      "poi_type": "Health and Wellness",
      "poi_address": "2731 S Harvard Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Hair styling salon with a friendly staff and a warm atmosphere, offering cuts and coloring services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2872-724e-b8b3-c3e2a5fa5edb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2872-724e-b8b3-c3e2a5fa5edb",
        "storage_key": "property/6767906449165591/019cfb3b-2872-724e-b8b3-c3e2a5fa5edb.webp",
        "width": 960,
        "height": 893
      },
      "poi_business_url": "http://www.iidentitysalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9820300745508314431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iidentity-salon",
      "poi_latitude": "36.1232992",
      "poi_longitude": "-95.9400579",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-747-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8vHnFGTtocRP92Gc3-3SIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_5355b80c-c873-421b-8f5a-ac9fed1ea3dd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "9142 E 31st St, Tulsa, OK 74145, USA",
      "poi_short_description": "Gym offering cardio and strength-training equipment, as well as Pilates, yoga, and cycling classes.",
      "poi_long_description": "People say this gym offers a wide variety of new equipment, including free weights, machines, and cardio options, as well as classes and tanning booths. They highlight the clean facilities, spacious layout, and 24/7 availability, making it convenient for people with unpredictable schedules. They also like the friendly, helpful, and understanding staff, and the welcoming, non-judgmental atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-28cb-73df-b5a4-010df80f4da0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-28cb-73df-b5a4-010df80f4da0",
        "storage_key": "property/6767906449165591/019cfb3b-28cb-73df-b5a4-010df80f4da0.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/east-tulsa-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16362762748097342813&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.1175059",
      "poi_longitude": "-95.8708861",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-438-0193",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJh4own9SMtocRXS1WmAY2FOM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6acc1647-4330-4fbc-9573-1452bdb3babd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "4915 E 41st St Suite A, Tulsa, OK 74135, USA",
      "poi_short_description": "Beauty retailer carrying a wide selection of products and offering salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-28cb-73df-b5a3-febe529730c0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-28cb-73df-b5a3-febe529730c0",
        "storage_key": "property/6767906449165591/019cfb3b-28cb-73df-b5a3-febe529730c0.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-131",
      "poi_directions_map_url": "https://maps.google.com/?cid=10581466912609131404&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.1058946",
      "poi_longitude": "-95.9208289",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-664-5916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJWeUzsceStocRjNudEBjs2JI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_3648263d-a716-438e-bce1-1df7446c84e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-28f4-70ed-a9ff-ea653047444d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-28f4-70ed-a9ff-ea653047444d",
        "storage_key": "property/6767906449165591/019cfb3b-28f4-70ed-a9ff-ea653047444d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 21 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d5-735a-a357-57479834be64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d5-735a-a357-57479834be64",
        "storage_key": "property/6767906449165591/019cfb3b-32d5-735a-a357-57479834be64.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_5c071fee-0a92-4dd1-87e0-195f9a8270e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-29aa-7004-a4b6-972788d7671e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-29aa-7004-a4b6-972788d7671e",
        "storage_key": "property/6767906449165591/019cfb3b-29aa-7004-a4b6-972788d7671e.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d5-735a-a357-57479834be64.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d5-735a-a357-57479834be64",
        "storage_key": "property/6767906449165591/019cfb3b-32d5-735a-a357-57479834be64.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_28b1fad8-6b79-4e2e-a3b6-78505ded10b9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2996-7689-a261-e2f39de2b552.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2996-7689-a261-e2f39de2b552",
        "storage_key": "property/6767906449165591/019cfb3b-2996-7689-a261-e2f39de2b552.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 29 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-0489a851afcb",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_0727d0d4-4668-4039-b4bb-635b4ee4fd7d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2a3e-77fa-9add-e3ae112d61a1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2a3e-77fa-9add-e3ae112d61a1",
        "storage_key": "property/6767906449165591/019cfb3b-2a3e-77fa-9add-e3ae112d61a1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-0489a851afcb",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b18f86ed-eab5-46cb-9bad-5eb46878f1ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2b0e-76ba-90fd-962d9016f3e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2b0e-76ba-90fd-962d9016f3e8",
        "storage_key": "property/6767906449165591/019cfb3b-2b0e-76ba-90fd-962d9016f3e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 38 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-0489a851afcb",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_29e1e517-19ff-4cdf-82fe-9f69061222a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2c32-7009-ab39-704a8dd8d84f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2c32-7009-ab39-704a8dd8d84f",
        "storage_key": "property/6767906449165591/019cfb3b-2c32-7009-ab39-704a8dd8d84f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-0489a851afcb",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ab2c710e-ada3-4e38-90cb-dfa45b470c86",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2c33-747f-8012-97d8c23af1ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2c33-747f-8012-97d8c23af1ea",
        "storage_key": "property/6767906449165591/019cfb3b-2c33-747f-8012-97d8c23af1ea.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-0489a851afcb",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_081b653e-fdac-42ac-9523-6922ffc0fa24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2e8b-76bd-acd2-df0003f2b933.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2e8b-76bd-acd2-df0003f2b933",
        "storage_key": "property/6767906449165591/019cfb3b-2e8b-76bd-acd2-df0003f2b933.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 0 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_ed59102f-751e-46f4-b47a-92d32ae8eb1e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2ccd-73b4-8518-a1fa7853369a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2ccd-73b4-8518-a1fa7853369a",
        "storage_key": "property/6767906449165591/019cfb3b-2ccd-73b4-8518-a1fa7853369a.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_90eb5908-16f8-490d-9deb-0b3427242d74",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2dbb-73cc-8d84-9c7cbfd0625a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2dbb-73cc-8d84-9c7cbfd0625a",
        "storage_key": "property/6767906449165591/019cfb3b-2dbb-73cc-8d84-9c7cbfd0625a.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_596fe8d2-b257-495f-b08c-8dc440f0bdd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 44 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_561d6a92-6702-4ff7-bdda-a52aaf8dd5e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-2ddc-73ae-bc51-79f902b9e3ec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3b-2ddc-73ae-bc51-79f902b9e3ec",
        "storage_key": "property/6767906449165591/019cfb3b-2ddc-73ae-bc51-79f902b9e3ec.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_6a8c0db4-c5b6-4249-8b71-17057cbf297c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Jarman Elementary School",
      "poi_type": "Education",
      "poi_address": "9015 E 79th St, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://unionps.org/index.php?pageID=426682_3",
      "poi_directions_map_url": "https://maps.google.com/?cid=15163329848068604185&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jarman-elementary-school",
      "poi_latitude": "36.0504608",
      "poi_longitude": "-95.8761305",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-357-4335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-clnx8GNtocRGQE1dij4btI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_d22f4f38-acb8-4f03-b771-e18c95d538eb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Union 6th/7th Grade Center",
      "poi_type": "Education",
      "poi_address": "10100 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-ca2a-7618-aee5-b43dc37600a9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ca2a-7618-aee5-b43dc37600a9",
        "storage_key": "property/6767906449165591/019d7911-ca2a-7618-aee5-b43dc37600a9.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12357368135835625738&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-6th-7th-grade-center",
      "poi_latitude": "36.0750199",
      "poi_longitude": "-95.8647424",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-357-4326",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJG0q97M9mtocRCqk279gwfqs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4f05e500-c09d-4a5e-8768-6f1ce012b98d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Union Eighth Grade Center",
      "poi_type": "Education",
      "poi_address": "6501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-c9e8-77fb-9216-7ba17bd8b2d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c9e8-77fb-9216-7ba17bd8b2d8",
        "storage_key": "property/6767906449165591/019d7911-c9e8-77fb-9216-7ba17bd8b2d8.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8773159022692442711&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-eighth-grade-center",
      "poi_latitude": "36.0671931",
      "poi_longitude": "-95.8503859",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-357-4325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJwUczVGMtocRV6KYIaaFwHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_72f975a8-f233-46e8-afdc-a97a4ec48648",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Union High School Freshman Academy",
      "poi_type": "Education",
      "poi_address": "7616 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-caf0-75af-a256-531b3111707f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-caf0-75af-a256-531b3111707f",
        "storage_key": "property/6767906449165591/019d7911-caf0-75af-a256-531b3111707f.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://ufa.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11673188432274153300&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school-freshman-academy",
      "poi_latitude": "36.0524715",
      "poi_longitude": "-95.8526699",
      "poi_miles_from_property": "2.1 mi",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-357-4324",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJNSlfnDaMtocRVF_mLQh__6E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5336fc71-a596-4e52-8ce2-7bfb55d53586",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Union High School",
      "poi_type": "Education",
      "poi_address": "6636 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-c9e5-71ea-a6e0-74f87e7d9814.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c9e5-71ea-a6e0-74f87e7d9814",
        "storage_key": "property/6767906449165591/019d7911-c9e5-71ea-a6e0-74f87e7d9814.webp",
        "width": 1000,
        "height": 700
      },
      "poi_business_url": "https://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2856521135297069003&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school",
      "poi_latitude": "36.0666635",
      "poi_longitude": "-95.8701703",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-357-4323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB7WuyaSNtocRy__GitZmpCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_579572a5-f665-4bed-9c62-589cf1e8da3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Peace Academy",
      "poi_type": "Education",
      "poi_address": "4620 S Irvington Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-d4f2-7166-a98c-de2c1a7fa30f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d4f2-7166-a98c-de2c1a7fa30f",
        "storage_key": "property/6767906449165591/019d7911-d4f2-7166-a98c-de2c1a7fa30f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://patulsa.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13057648211272518822&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "peace-academy",
      "poi_latitude": "36.096653",
      "poi_longitude": "-95.911935",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-627-1040",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJIcMahL2StocRpszpot0VNrU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_5a883605-203c-4129-9da7-24cf67e8011e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Mingo Valley Christian",
      "poi_type": "Education",
      "poi_address": "8304 S 107th E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-d579-709f-bf30-1b286c9c4b35.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d579-709f-bf30-1b286c9c4b35",
        "storage_key": "property/6767906449165591/019d7911-d579-709f-bf30-1b286c9c4b35.webp",
        "width": 1024,
        "height": 576
      },
      "poi_business_url": "http://www.mingovalley.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5984708029432634189&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mingo-valley-christian",
      "poi_latitude": "36.0430605",
      "poi_longitude": "-95.8575741",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-294-0404",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd5jMw5-NtocRTZvCkj70DVM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_41feda27-59d5-4fa7-8f61-3b2539bc822a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-d6f3-71bd-baf9-d29bbebb7c90.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d6f3-71bd-baf9-d29bbebb7c90",
        "storage_key": "property/6767906449165591/019d7911-d6f3-71bd-baf9-d29bbebb7c90.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "10.1 mi",
      "poi_walking_minutes": "3 hours 44 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d9-757f-8344-b97b533de258",
        "storage_key": "property/6767906449165591/019cfb3b-32d9-757f-8344-b97b533de258.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_e00ce349-02b0-4744-a3ab-0925791c1cad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "9111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "People say this steakhouse serves great steaks, including filet, ribeye, and New York strip, as well as Parmesan-crusted chicken and shrimp. They also highlight the friendly and attentive service, and the quiet atmosphere.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-d5a5-766d-a001-2eaf003ae41d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d5a5-766d-a001-2eaf003ae41d",
        "storage_key": "property/6767906449165591/019d7911-d5a5-766d-a001-2eaf003ae41d.webp",
        "width": 1280,
        "height": 660
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/ok/tulsa/tulsa/5345?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:tulsa-ok-5345_pl:locurl_rd:1291",
      "poi_directions_map_url": "https://maps.google.com/?cid=17156575932075566986&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "36.0614",
      "poi_longitude": "-95.874818",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-294-0244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuVECS7yNtocRimdhKelmGO4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_69313f76-18a9-4eb1-984b-9de2d0b48198",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Sonic Drive-In",
      "poi_type": "Restaurants",
      "poi_address": "8030 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Fast-food burger & fries joint with an old-school feel, including retro drive-in service.",
      "poi_long_description": "Some diners say this fast food restaurant offers decent food.\n\nOther reviews mention the service can be slow and customer service can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-e239-7684-b1a4-3ccce268a608.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e239-7684-b1a4-3ccce268a608",
        "storage_key": "property/6767906449165591/019d7911-e239-7684-b1a4-3ccce268a608.webp",
        "width": 1280,
        "height": 560
      },
      "poi_business_url": "http://www.sonicdrivein.com/locations/us/ok/tulsa/8030-s--lewis/store-3055?utm_source=google-my-business&utm_medium=organic&utm_campaign=website-link&y_source=1_MjAzMzg0ODQzMy03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=5047357944934098230&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sonic-drive-in",
      "poi_latitude": "36.0467721",
      "poi_longitude": "-95.9583518",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-492-3396",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_yutJMGTtocRNuUKEk_RC0Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_12ad42bb-2d76-49a9-9be8-d5dc7a97aec5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Sake2Me Sushi",
      "poi_type": "Restaurants",
      "poi_address": "9205 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual Japanese restaurant offering all-you-can-eat sushi & sashimi, plus noodles & teriyaki dishes.",
      "poi_long_description": "People say this sushi restaurant offers delicious and fresh sushi, including a wide variety of rolls and sashimi, as well as teriyaki chicken and calamari. They highlight the generous portions, reasonable prices, and the all-you-can-eat option, which they find to be a great value. They also like the chill and relaxed atmosphere, and the friendly and attentive staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-e39e-759b-9ee1-3d9138d0fe32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e39e-759b-9ee1-3d9138d0fe32",
        "storage_key": "property/6767906449165591/019d7911-e39e-759b-9ee1-3d9138d0fe32.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://sake2mesushi.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9793506518580779662&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sake2me-sushi",
      "poi_latitude": "36.061592",
      "poi_longitude": "-95.873192",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "6 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-249-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJSeCG1folTIYRjtp6WUqG6Yc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_11e34608-0d77-4aa9-bd93-241d9f26eeff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7019 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "People say this Italian restaurant serves delicious soups, salads, breadsticks, and entrees. They also highlight the generous portions, great prices, and friendly, efficient service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-e717-765a-8129-332e677d1896.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e717-765a-8129-332e677d1896",
        "storage_key": "property/6767906449165591/019d7911-e717-765a-8129-332e677d1896.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/tulsa/tulsa-memorial/1054?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:tulsa-ok-1054_pl:locurl_rd:1028",
      "poi_directions_map_url": "https://maps.google.com/?cid=1956020961746126449&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "36.062018",
      "poi_longitude": "-95.885692",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-254-0082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ar2VJCNtocRcYYYhrMuJRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_e720fa40-5b0f-437b-aede-d4da27ade3c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Blue Coast Juicy Seafood",
      "poi_type": "Restaurants",
      "poi_address": "8215 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual venue serving fried baskets, boiled bags of seafood, and grilled fish such as shrimp and crab to eat in or take away, plus beer, wine, and hard liquor.",
      "poi_long_description": "People say this restaurant serves delicious seafood boils, especially the E Combo Special with lobster tail, shrimp, and snow crab. They also highlight the generous portions, flavorful seasoning, and reasonable prices for the boil combos.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-ebda-7391-8143-917417e168d0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ebda-7391-8143-917417e168d0",
        "storage_key": "property/6767906449165591/019d7911-ebda-7391-8143-917417e168d0.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://bluecoastjuicytulsa.com/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=2767304385105026187&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "blue-coast-juicy-seafood",
      "poi_latitude": "36.0613365",
      "poi_longitude": "-95.8850021",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-258-0188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5aprcuiNtocRi9yQK61wZyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6e1aa028-d619-42a8-aec8-306034618093",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Waffle House",
      "poi_type": "Restaurants",
      "poi_address": "7022 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Simple chain spot offering American diner fare & all-day breakfast, including signature waffles.",
      "poi_long_description": "People say this breakfast restaurant serves good, consistent food, including waffles, eggs, and hash browns. They also highlight the affordable prices, friendly and welcoming atmosphere, and fast service.\n\nSome reviews mention the service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-ec2b-708e-a2cd-6a81a8782062.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ec2b-708e-a2cd-6a81a8782062",
        "storage_key": "property/6767906449165591/019d7911-ec2b-708e-a2cd-6a81a8782062.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://locations.wafflehouse.com/tulsa-ok-980",
      "poi_directions_map_url": "https://maps.google.com/?cid=13946780258865725072&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "waffle-house",
      "poi_latitude": "36.0620021",
      "poi_longitude": "-95.869057",
      "poi_miles_from_property": "0.5 mi",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-252-5176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ97l3QbqNtocRkD4fksDqjME",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_f694c8ab-b684-4383-8d16-8ffd47c6b950",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "7110 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "People say this cafe offers a variety of soups, salads, and sandwiches, including a new chicken salad with cranberries. They also highlight the convenient customization options, such as adjusting syrup levels in drinks, and the availability of nutritious options like salads with fresh ingredients.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-f4ec-77fe-9bb6-f358256f0ad5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f4ec-77fe-9bb6-f358256f0ad5",
        "storage_key": "property/6767906449165591/019d7911-f4ec-77fe-9bb6-f358256f0ad5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/ok/tulsa/7110-s-101st-e-ave?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=202535&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=13855183562628129273&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "36.0603787",
      "poi_longitude": "-95.8640527",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "17 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-250-0196",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-227e-764b-8841-f01a402c2b6c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-227e-764b-8841-f01a402c2b6c",
        "storage_key": "property/6767906449165591/019d7912-227e-764b-8841-f01a402c2b6c.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJa8CALLGNtocR-eFH1AqAR8A",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cafe"
    },
    {
      "id": "custom_a494b6eb-dd91-4299-9862-b627f04af0da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Chuy's",
      "poi_type": "Restaurants",
      "poi_address": "10808 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_long_description": "People say this Tex-Mex restaurant serves delicious fajitas, chile rellenos, and shrimp tacos. They also highlight the reasonable prices, fun and relaxed vibe, and friendly service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-f45d-7613-85be-764528e52e4a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f45d-7613-85be-764528e52e4a",
        "storage_key": "property/6767906449165591/019d7911-f45d-7613-85be-764528e52e4a.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.chuys.com/locations/ok/tulsa/tulsa-ok/6031?cmpid=br:chy_ag:ie_ch:loc_ca:CHYGMB_sn:gmb_gt:tulsa-ok-6031_pl:locurl_rd:1030",
      "poi_directions_map_url": "https://maps.google.com/?cid=15724210836110639618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chuy-s",
      "poi_latitude": "36.0603153",
      "poi_longitude": "-95.8561867",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-252-0405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TEdVbONtocRAgK563GeN9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_3835ceb3-f768-49e5-b328-ace8adf604d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Fish Daddy's Grill House",
      "poi_type": "Restaurants",
      "poi_address": "10624 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Lively eatery & bar dishing up grilled, blackened or fried fish platters & Cajun specialties.",
      "poi_long_description": "People say this seafood restaurant serves delicious catfish, shrimp, and salmon, and the onion rings are a must-try. They highlight the excellent value, with generous portions and reasonable prices, and the cozy, welcoming atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-fbbb-750c-94a8-c1b4b888600b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fbbb-750c-94a8-c1b4b888600b",
        "storage_key": "property/6767906449165591/019d7911-fbbb-750c-94a8-c1b4b888600b.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.fdtulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7311857581283797504&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "fish-daddy-s-grill-house",
      "poi_latitude": "36.0602301",
      "poi_longitude": "-95.8578103",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-307-1388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-862f3c8f8e80",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-862f3c8f8e80.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJo40vf7ONtocRAOqq9LrveGU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_6f4dd8ac-8814-4c43-bbbd-0900f13ce8d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Hobby Lobby",
      "poi_type": "Shopping & Retail",
      "poi_address": "9717 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain carrying a variety of arts & crafts materials, plus party supplies, fabric & home-decor items.",
      "poi_long_description": "People say this craft store offers a wide selection of products for hobbies and decorating, including yarn, fabric, and seasonal decorations. They highlight the good prices and the clean, organized store. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-fcb1-73d3-9681-f2f332b242f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fcb1-73d3-9681-f2f332b242f9",
        "storage_key": "property/6767906449165591/019d7911-fcb1-73d3-9681-f2f332b242f9.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hobbylobby.com/stores/search/3",
      "poi_directions_map_url": "https://maps.google.com/?cid=5139651924585796964&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hobby-lobby",
      "poi_latitude": "36.0639533",
      "poi_longitude": "-95.8669013",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-254-0290",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJVS6DnLqNtocRZNUWwjG2U0c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_e710d55f-5731-4311-878b-1bc8afc81bd1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "SEPHORA",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr STE 215, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain with a selection of upmarket makeup, perfumes, beauty & skincare products.",
      "poi_long_description": "Retail chain with a selection of upmarket makeup, perfumes, beauty & skincare products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-fd20-70f7-b5c1-378f9d4a914b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fd20-70f7-b5c1-378f9d4a914b",
        "storage_key": "property/6767906449165591/019d7911-fd20-70f7-b5c1-378f9d4a914b.webp",
        "width": 500,
        "height": 277
      },
      "poi_business_url": "https://www.sephora.com/happening/stores/tulsa-woodland-hills?utm_source=gmb&utm_medium=Yext",
      "poi_directions_map_url": "https://maps.google.com/?cid=14577707517912436268&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sephora",
      "poi_latitude": "36.063001",
      "poi_longitude": "-95.881663",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-307-8434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRLE62ZMBrTso",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "cosmetics_store"
    },
    {
      "id": "custom_de067d2b-4cee-4966-a8dd-36c64cefc7d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "JD Sports",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr #279, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain carrying a large selection of athletic footwear, apparel & accessories, plus fan gear.",
      "poi_long_description": "People say this shoe store offers a variety of shoes.\n\nOther reviews mention the service can be unhelpful and the staff can be unprofessional.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7911-ff40-74c8-8ef3-52349a32b556.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ff40-74c8-8ef3-52349a32b556",
        "storage_key": "property/6767906449165591/019d7911-ff40-74c8-8ef3-52349a32b556.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.jdsports.com/?utm_source=googlemybusiness&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=16883722969115031092&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jd-sports",
      "poi_latitude": "36.0630794",
      "poi_longitude": "-95.8804955",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-294-1047",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJbTxoTpCNtocRNHY0LJYIT-o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shoe_store"
    },
    {
      "id": "custom_20ef9f15-409e-447b-9e3c-e7fd8791b8b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "6625 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retailer stocking toys, clothing, electronics, home goods, furniture, groceries and more.",
      "poi_long_description": "People say this department store offers a wide variety of products, including groceries, clothing, and household items. They also highlight the convenient one-stop shopping experience and the affordable prices.\n\nOther reviews mention the store can be busy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-0430-75f9-a213-f6f4adbb053b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0430-75f9-a213-f6f4adbb053b",
        "storage_key": "property/6767906449165591/019d7912-0430-75f9-a213-f6f4adbb053b.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/894-tulsa-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=18164824787754373520&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.0674096",
      "poi_longitude": "-95.8830124",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-294-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJjfQHJZqNtocRkFFPMedrFvw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d0a50825-da88-4410-98a3-8d688afd71c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "6922 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this warehouse club offers a wide selection of products and good prices. They also highlight the friendly staff and convenient bulk shopping.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-04cf-758d-9a83-8da86f88df5a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-04cf-758d-9a83-8da86f88df5a",
        "storage_key": "property/6767906449165591/019d7912-04cf-758d-9a83-8da86f88df5a.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.samsclub.com/club/6342-tulsa-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=2142616615335699436&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club",
      "poi_latitude": "36.0628489",
      "poi_longitude": "-95.8716547",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-252-9503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOxq7n7uNtocR7CPvpnUavB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_1c5351fe-2067-41a5-971b-2ad21634f0f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9808 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has helpful and friendly staff who are knowledgeable about their areas. They also highlight the well-stocked store and efficient delivery service.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-0530-77a4-bc08-5ea3211af6e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0530-77a4-bc08-5ea3211af6e8",
        "storage_key": "property/6767906449165591/019d7912-0530-77a4-bc08-5ea3211af6e8.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/South-Tulsa/OK/Tulsa/74133/3903?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1237148003252488434&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.0595045",
      "poi_longitude": "-95.8665226",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-459-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvaH1r7CNtocR8shy5I07KxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_0490940d-7660-436c-9c95-becef497a590",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "DICK'S Sporting Goods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7523 S Olympia Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_long_description": "Sporting goods chain with equipment, apparel & footwear for athletics, outdoor recreation & fitness.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-06d4-74bc-b30b-a789b0e38191.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-06d4-74bc-b30b-a789b0e38191",
        "storage_key": "property/6767906449165591/019d7912-06d4-74bc-b30b-a789b0e38191.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.dickssportinggoods.com/ok/tulsa/1000/?seo=localpack",
      "poi_directions_map_url": "https://maps.google.com/?cid=2275925583343426123&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dick-s-sporting-goods",
      "poi_latitude": "36.0536757",
      "poi_longitude": "-96.0020156",
      "poi_miles_from_property": "8.7 mi",
      "poi_walking_minutes": "3 hours 14 mins",
      "poi_biking_minutes": "1 hour 9 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 918-447-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ1TjN3WmUtocRS5poekK2lR8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_18ab36e1-07e8-465c-ac82-53c7de37020b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "People say this department store offers a great selection of products and easy returns. They also highlight the quick and efficient service provided by the SFS and drive-up crew, and the helpfulness of some employees.\n\nOther reviews mention the self-checkout can be unavailable.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-0cb7-74df-ba8d-5dfd48a3b620.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0cb7-74df-ba8d-5dfd48a3b620",
        "storage_key": "property/6767906449165591/019d7912-0cb7-74df-ba8d-5dfd48a3b620.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.target.com/sl/tulsa-se/1782",
      "poi_directions_map_url": "https://maps.google.com/?cid=11072252321475274749&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "target",
      "poi_latitude": "36.0628683",
      "poi_longitude": "-95.8567584",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-307-8161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ67yjULONtocR_ScHtdKKqJk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_d4b2e1df-35c1-4b82-b14e-c655d8a7e208",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11011 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Shoppers say this department store offers a wide selection of products, great sales, and good prices. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-0d1d-703f-bf50-77c0bbde1700.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0d1d-703f-bf50-77c0bbde1700",
        "storage_key": "property/6767906449165591/019d7912-0d1d-703f-bf50-77c0bbde1700.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/tulsa-425.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10465943342793208862&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "36.0629677",
      "poi_longitude": "-95.8533535",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-461-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwxxHW0yMtocRHrSN8gSAPpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_230a7cac-99b9-4834-8b69-5d90eb8ddf49",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "10303 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide variety of products, including TVs, laptops, and appliances. They also highlight the knowledgeable and helpful staff, and the convenient online ordering and pick-up service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-0e87-75ff-a2a9-69ce57729520.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0e87-75ff-a2a9-69ce57729520",
        "storage_key": "property/6767906449165591/019d7912-0e87-75ff-a2a9-69ce57729520.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.bestbuy.com/ok/tulsa/10303-e-71st-st-221.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=2994601933184998961&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "36.064164",
      "poi_longitude": "-95.86075",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-250-6819",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-09e17d3573b3",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-09e17d3573b3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5SOWULGNtocRMZ4wl5f2jik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_2462d39f-fc9d-4b33-b991-c792c989c87b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Leake Park",
      "poi_type": "Entertainment",
      "poi_address": "7714 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-15a8-75e8-b419-17c9c8018e13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-15a8-75e8-b419-17c9c8018e13",
        "storage_key": "property/6767906449165591/019d7912-15a8-75e8-b419-17c9c8018e13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/government/departments/park-and-recreation/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15363708563321327691&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "leake-park",
      "poi_latitude": "36.0576247",
      "poi_longitude": "-95.88987240000002",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-596-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-0489a851afcb",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJLTqelI2NtocRSxBltYnbNtU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bd80e4ac-7553-42c2-bea8-686a6c76de18",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Cinemark Tulsa and IMAX",
      "poi_type": "Entertainment",
      "poi_address": "10802 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers a wide selection of movies, including IMAX and 3D options, and has comfortable reclining seats. They highlight the delicious popcorn, the good sound and picture quality, and the clean theaters and bathrooms. They also like the friendly and helpful staff, and the efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-1333-715b-a4e7-b8728b57eafd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-1333-715b-a4e7-b8728b57eafd",
        "storage_key": "property/6767906449165591/019d7912-1333-715b-a4e7-b8728b57eafd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/ok-tulsa/cinemark-tulsa-and-imax?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxOTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9116249517963305424&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-tulsa-and-imax",
      "poi_latitude": "36.05829689999999",
      "poi_longitude": "-95.8564432",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-250-1956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-238a-74df-8d6f-3e3633ef766f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-238a-74df-8d6f-3e3633ef766f",
        "storage_key": "property/6767906449165591/019d7912-238a-74df-8d6f-3e3633ef766f.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ12hyVbONtocR0GEH-qJsg34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_f2400366-cc11-4a72-aa27-8ee3e19250e6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "River Spirit Casino Resort",
      "poi_type": "Entertainment",
      "poi_address": "8330 Riverside Pkwy, Tulsa, OK 74137, USA",
      "poi_short_description": "Riverside casino offering a steakhouse, casual eateries, table & electronic gaming, & weekend shows.",
      "poi_long_description": "People say this casino offers a wide variety of slot machines, live music, and entertainment venues, including a concert venue and a sports bar. They also highlight the clean and spacious rooms with beautiful views, the friendly and helpful staff, and the convenient amenities such as free valet parking and keyless check-in.\n\nOther reviews mention the machines can be tight.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-15fc-744c-acfb-27148e9be591.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-15fc-744c-acfb-27148e9be591",
        "storage_key": "property/6767906449165591/019d7912-15fc-744c-acfb-27148e9be591.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.riverspirittulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12292203165626239741&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "river-spirit-casino-resort",
      "poi_latitude": "36.0419162",
      "poi_longitude": "-95.9638914",
      "poi_miles_from_property": "6.1 mi",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 888-748-3731",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32cd-7758-ab8a-88d8d1bac466",
        "storage_key": "property/6767906449165591/019cfb3b-32cd-7758-ab8a-88d8d1bac466.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJscNp2cGTtocR_YoV-qatlqo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "casino"
    },
    {
      "id": "custom_6c49af37-b7a3-4b08-ba96-9f2a1c94895d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Turkey Mountain",
      "poi_type": "Entertainment",
      "poi_address": "6800 S Elwood Ave, Tulsa, OK 74132, USA",
      "poi_short_description": "Hilly, forested park featuring jogging, biking & horseback riding trails, plus restrooms.",
      "poi_long_description": "People say this park offers well-maintained trails suitable for hiking, biking, and running, with beautiful views of the city skyline and Arkansas River. They highlight the peaceful and refreshing atmosphere, perfect for connecting with nature and enjoying outdoor activities. They also like the new trail additions and upgrades, and the friendly community of fellow hikers and bikers. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019d7912-19e1-70eb-a479-5e0de98bbcdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-19e1-70eb-a479-5e0de98bbcdd",
        "storage_key": "property/6767906449165591/019d7912-19e1-70eb-a479-5e0de98bbcdd.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.riverparks.org/experience/turkey-mountain",
      "poi_directions_map_url": "https://maps.google.com/?cid=1129856788357496640&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "turkey-mountain",
      "poi_latitude": "36.0648571",
      "poi_longitude": "-95.9934169",
      "poi_miles_from_property": "7.4 mi",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "1 hour 1 min",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-596-2001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-0489a851afcb",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVWFdbHyUtocRQL8cRcMOrg8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_52a78b0e-ec76-4f7a-8fa4-4a5322a2ac4c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "poi_name": "Hunter Park Pond",
      "poi_type": "Entertainment",
      "poi_address": "Creek Tumpike Trl, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2691387023598245280&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hunter-park-pond",
      "poi_latitude": "36.0293125",
      "poi_longitude": "-95.9110908",
      "poi_miles_from_property": "4.4 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3b-32d1-707f-8c48-0489a851afcb",
        "storage_key": "property/6767906449165591/019cfb3b-32d1-707f-8c48-0489a851afcb.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAufeRtocRoFWrBj26WSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    }
  ],
  "office_hours": [
    {
      "id": "ec_3a83356677b32ce90f233f12",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7cfbeccb20e81da2fba31c74",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "15:00"
    },
    {
      "id": "ec_e4b018ef3d560e2702f6e995",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "15:00"
    },
    {
      "id": "ec_a047fec84e02339fd01f0f1c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_e7a9cde9c545d2b1224de44e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    }
  ],
  "reviews": [
    {
      "id": "custom_a8535583-39e5-4c60-8214-062a3ac8883c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "rating": "5.0",
      "name": "Maria Junie Miller",
      "text": "The maintenance is very kind and very quick to respond when you need them. Management is great they are always listening to my concerns.\nI will recommend this place to my love one and friend.",
      "date": "2025-10-04",
      "title": ""
    },
    {
      "id": "custom_8f663247-fe34-49a3-8bcf-ad104a1d543a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "rating": "5.0",
      "name": "Tina Birchett",
      "text": "I have been at Chardonnay Apts, just over a year now. Marina and the maintenance crew are on top of their game! I have never had an issue with anything. Thank you all so much for doing a great job!",
      "date": "2025-09-02",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_dc94146b-9f69-48a3-bcbf-08542a2eede6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-d162-753d-a9a1-2bdf7816a089.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 degree view of a modern kitchen with granite countertops and pendant lighting.",
        "public_id": "019cfb3b-d162-753d-a9a1-2bdf7816a089",
        "storage_key": "property/6767906449165591/019cfb3b-d162-753d-a9a1-2bdf7816a089.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Chardonnay Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=5f478c4cd25e9a53a51433fe&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-1f92-731c-a71c-5736e862a496",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "chardonnay",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591"
    },
    {
      "lead_collector_id": "019cf79e-2005-7259-b48d-375a7c606726",
      "lead_source": "LANDING_PAGE",
      "name": "chardonnay",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "generator",
      "page_item_url": "chardonnay-apartments-with-in-unit-laundry-tulsa",
      "search_query": "apartments with in-unit laundry Tulsa",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry in Tulsa",
      "h2_subtitle": "Discover the convenience of in-unit laundry at Chardonnay, located in vibrant South Tulsa. Our luxurious apartments are designed for modern living.",
      "page_copy": "Experience ultimate convenience at Chardonnay in South Tulsa, where each apartment offers in-unit laundry facilities. This feature adds a touch of luxury, ensuring you enjoy hassle-free living with more time to focus on what matters most.\n\nBeyond in-unit laundry, our community pampers residents with amenities like a refreshing pool, a welcoming clubhouse, and a pet-friendly courtyard. Embrace a lifestyle of ease and comfort in our spacious one and two-bedroom apartments. Schedule a tour today and make Chardonnay your new home!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
      "featured_image_media": {
        "alt_text": "Chardonnay Apartment Homes monument sign",
        "public_id": "019cfb3b-0f97-73cd-8e56-062016671637",
        "storage_key": "property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Tulsa",
      "seo_description": "Enjoy the convenience of in-unit laundry at Chardonnay in Tulsa. Discover comfort and style in our spacious apartments. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "generator",
      "page_item_url": "chardonnay-pet-friendly-apartments-south-tulsa",
      "search_query": "pet-friendly apartments South Tulsa",
      "category": "Amenity",
      "h1_title": "Pet-Friendly Apartments in South Tulsa",
      "h2_subtitle": "Chardonnay offers the perfect pet-friendly setting in South Tulsa. Explore our comfortable and stylish apartment living for you and your furry friends.",
      "page_copy": "At Chardonnay in South Tulsa, we understand that pets are family too. Our pet-friendly apartments are designed to welcome you and your furry companions. Enjoy leisurely walks in our specially designed pet-friendly courtyard and come home to a comfortable, stylish space.\n\nOur spacious one and two-bedroom apartments provide ample room for you and your pets to thrive. You'll also love our collection of amenities, including a refreshing pool and a cozy clubhouse. With a convenient location in South Tulsa, discover the perfect blend of luxury and pet-friendly living at Chardonnay. Schedule a visit and see for yourself today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
      "featured_image_media": {
        "alt_text": "Chardonnay Apartment Homes monument sign",
        "public_id": "019cfb3b-0f97-73cd-8e56-062016671637",
        "storage_key": "property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments in South Tulsa",
      "seo_description": "Chardonnay offers pet-friendly living in South Tulsa. Spacious apartments and amenities perfect for you and your pets. Book a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "generator",
      "page_item_url": "chardonnay-apartments-with-pool-tulsa-ok",
      "search_query": "apartments with a pool Tulsa OK",
      "category": "Amenity",
      "h1_title": "Apartments with a Pool in Tulsa, OK",
      "h2_subtitle": "Dive into luxury at Chardonnay's apartments with a pool in Tulsa, OK. Enjoy resort-like amenities in a vibrant South Tulsa location.",
      "page_copy": "Chardonnay in Tulsa, OK, offers a refreshing escape with our beautiful pool, perfect for relaxation and leisure. Our community is designed to provide resort-like amenities right at your doorstep, allowing you to enjoy the best of apartment living.\n\nChoose from our spacious one and two-bedroom apartments, complete with modern conveniences like in-unit laundry and a pet-friendly environment. Located in vibrant South Tulsa, Chardonnay is your gateway to a comfortable and stylish lifestyle. Book a tour today and discover why our apartments with a pool are the perfect choice for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
      "featured_image_media": {
        "alt_text": "Chardonnay Apartment Homes monument sign",
        "public_id": "019cfb3b-0f97-73cd-8e56-062016671637",
        "storage_key": "property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Pool in Tulsa, OK",
      "seo_description": "Discover Chardonnay's apartments with a pool in Tulsa, OK. Enjoy resort-like amenities and stylish living. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "generator",
      "page_item_url": "chardonnay-air-conditioned-apartments-near-74133",
      "search_query": "air conditioned apartments near 74133",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments Near 74133",
      "h2_subtitle": "Stay comfortable year-round in our air conditioned apartments near 74133. Enjoy modern living at Chardonnay in South Tulsa.",
      "page_copy": "Chardonnay provides a perfect retreat with our air conditioned apartments near the 74133 area in South Tulsa. Designed for comfort, our one and two-bedroom units ensure you enjoy a refreshing indoor atmosphere, regardless of the season.\n\nOur community offers more than just air conditioning. Dive into our pool, socialize at the clubhouse, or take a stroll with your pet in our welcoming courtyard. Located conveniently near popular South Tulsa destinations, Chardonnay combines style, comfort, and modern amenities. Schedule a tour today and experience it firsthand!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
      "featured_image_media": {
        "alt_text": "Chardonnay Apartment Homes monument sign",
        "public_id": "019cfb3b-0f97-73cd-8e56-062016671637",
        "storage_key": "property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Apartments Near 74133",
      "seo_description": "Comfortable air conditioned apartments near 74133 at Chardonnay in Tulsa. Enjoy modern amenities and stylish living. Book a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "generator",
      "page_item_url": "chardonnay-apartments-with-dog-park-tulsa",
      "search_query": "apartments with a dog park Tulsa",
      "category": "Amenity",
      "h1_title": "Apartments with a Dog Park in Tulsa",
      "h2_subtitle": "Chardonnay features apartments with access to a dog park in Tulsa. Experience pet-friendly living in a vibrant South Tulsa community.",
      "page_copy": "At Chardonnay, we offer more than just a place to live in Tulsa—we provide a pet-friendly haven featuring access to a fantastic dog park. Perfect for pet lovers, our community ensures your furry friend is just as thrilled to call our apartments home.\n\nOur one and two-bedroom apartments are spacious, modern, and perfect for both you and your pet. Alongside playful escapades at the dog park, residents enjoy a refreshing community pool and an inviting clubhouse. Located in South Tulsa, Chardonnay combines convenience with comfort, making it the ideal spot for you and your pet. Come see what makes us the perfect choice for pet-friendly living in Tulsa!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
      "featured_image_media": {
        "alt_text": "Chardonnay Apartment Homes monument sign",
        "public_id": "019cfb3b-0f97-73cd-8e56-062016671637",
        "storage_key": "property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with a Dog Park in Tulsa",
      "seo_description": "Chardonnay offers pet-friendly apartments with a dog park in Tulsa. Enjoy spacious living and great amenities. Visit us today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "generator",
      "page_item_url": "chardonnay-1-bedroom-apartments-south-tulsa",
      "search_query": "1 bedroom apartments south tulsa",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Explore spacious 1 bedroom apartments in South Tulsa at Chardonnay. Experience the blend of comfort and style tailored just for you.",
      "page_copy": "Discover Chardonnay's delightful community featuring 1 bedroom apartments in South Tulsa, designed to meet your lifestyle needs. Our thoughtfully designed layouts provide the ideal balance of comfort and style, making these apartments a perfect retreat.\n\nSituated in vibrant South Tulsa, Chardonnay offers residents access to amenities such as a refreshing swimming pool and a welcoming clubhouse. Each unit boasts modern conveniences like a range, microwave, and cable-ready setup. Whether you're looking to downsize or find a cozy space, our community provides what you need. Schedule a tour and see why these 1 bedroom apartments are the right fit for you.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
      "featured_image_media": {
        "alt_text": "Chardonnay Apartment Homes monument sign",
        "public_id": "019cfb3b-0f97-73cd-8e56-062016671637",
        "storage_key": "property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartments in South Tulsa",
      "seo_description": "Find your ideal 1 bedroom apartment in South Tulsa at Chardonnay. Enjoy modern amenities and comfort. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165591",
      "source": "generator",
      "page_item_url": "chardonnay-2-bedroom-apartments-tulsa-ok",
      "search_query": "2 bedroom apartments in tulsa ok",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments in Tulsa, OK",
      "h2_subtitle": "Discover spacious 2 bedroom apartments in Tulsa, OK at Chardonnay. Perfect for families or roommates seeking comfort and modern amenities.",
      "page_copy": "At Chardonnay in Tulsa, OK, our spacious 2 bedroom apartments are designed with both style and function in mind. Ideal for families or roommates, these apartments offer ample living space and modern amenities, creating a perfect setting for comfortable living.\n\nLocated in South Tulsa, Chardonnay ensures easy access to local attractions while offering residents a host of amenities, including a swimming pool and a pet-friendly courtyard. Each apartment comes equipped with a microwave, range, and is cable ready, ensuring that your new home is as convenient as it is welcoming. Experience living at its finest in our 2 bedroom apartments—contact us to schedule a tour today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
      "featured_image_media": {
        "alt_text": "Chardonnay Apartment Homes monument sign",
        "public_id": "019cfb3b-0f97-73cd-8e56-062016671637",
        "storage_key": "property/6767906449165591/019cfb3b-0f97-73cd-8e56-062016671637.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments in Tulsa, OK",
      "seo_description": "Explore 2 bedroom apartments in Tulsa, OK at Chardonnay. Enjoy spacious living with modern amenities. Book a tour now!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5154"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-P7VXN3H97D"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151764"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/chardonnay-apartments/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-W8X8HP4F"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165591/019d1bd7-62a4-702e-b0b1-4ad9ec444192.pdf"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "800-687-2989"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "65fb7002430eb259a3afa919"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImRrZTJzQnl4VERQNEZwZEdZZmNNUGc9PSIsInZhbHVlIjoibEpoWjBTVCtObGIrdDh4MjhVRlRLQT09IiwibWFjIjoiMWQ5NjE5ZDgwOGNmMDk2NzBkNTZjYTUzMGYwZjMxNzVlYTcwMTQ4NjNjZTA4ZDVhZDkyYTM2NjNkNDMwM2Q3MiJ9"
    }
  ],
  "custom_qb_id": "5154",
  "custom_ga4_id": "G-P7VXN3H97D",
  "custom_repli_id": "10041151764",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/chardonnay-apartments/register/",
  "custom_google_gtm_id": "GTM-W8X8HP4F",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165591/019d1bd7-62a4-702e-b0b1-4ad9ec444192.pdf",
  "custom_ppc_tracking_phone_number": "800-687-2989",
  "custom_residentboost_apartment_id": "65fb7002430eb259a3afa919",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImRrZTJzQnl4VERQNEZwZEdZZmNNUGc9PSIsInZhbHVlIjoibEpoWjBTVCtObGIrdDh4MjhVRlRLQT09IiwibWFjIjoiMWQ5NjE5ZDgwOGNmMDk2NzBkNTZjYTUzMGYwZjMxNzVlYTcwMTQ4NjNjZTA4ZDVhZDkyYTM2NjNkNDMwM2Q3MiJ9"
};

export const generatedAt = '2026-08-27T21:39:14.773Z';
